var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.325 20.925q-.3-.275-.3-.688 0-.412.3-.712l7.5-7.525L7.3 4.45Q7 4.175 7 3.762q0-.412.325-.712.275-.3.688-.3.412 0 .712.3l8.3 8.325q.15.125.213.287.062.163.062.338 0 .175-.062.337-.063.163-.213.288L8.7 20.95q-.275.3-.675.3t-.7-.325Z"}));
}

ArrowForward.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
